module.exports = __webpack_public_path__ + "img/phone.82243f9e.svg";